import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=c2612ebc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=c2612ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2612ebc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2612ebc')) {
      api.createRecord('c2612ebc', component.options)
    } else {
      api.reload('c2612ebc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=c2612ebc&scoped=true&", function () {
      api.rerender('c2612ebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26u8e383uWq7X/JS/teamMember.vue"
export default component.exports